export async function translateBatch(
  texts: string[],
  target: string
): Promise<string[]> {
  const endpoint = "https://api.cognitive.microsofttranslator.com";

  const key = import.meta.env.VITE_TRANSLATOR_KEY!;
  const region = import.meta.env.VITE_TRANSLATOR_REGION!;

  if (!key) {
    console.warn("no translator key")
  }
// console.log("key translateBatch", key);
  console.log("region translateBatch", region);
  // Map speech BCP-47 codes to Translator's expected language codes
  const mapToTranslatorCode = (code: string) => {
    if (!code) return code;
    if (code.startsWith("zh-")) {
      if (code === "zh-CN") return "zh-Hans"; // Simplified
      if (code === "zh-TW" || code === "zh-HK") return "zh-Hant"; // Traditional
      return "zh-Hans";
    }
    const short = code.split("-")[0];
    return short;
  };
  const targetCode = mapToTranslatorCode(target);

  const res = await fetch(
    `${endpoint}/translate?api-version=3.0&to=${encodeURIComponent(
      targetCode
    )}`,
    {
      method: "POST",
      headers: {
        "Ocp-Apim-Subscription-Key": key,
        "Ocp-Apim-Subscription-Region": region,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(texts.map((Text) => ({ Text }))),
    }
  );
  if (!res.ok) throw new Error(await res.text());
  const json = await res.json();
  const raw = json.map((o: any) => o.translations[0].text as string);
  try {
    const useNorm =
      String(import.meta.env.VITE_TRANSLATE_NORMALIZE || "1") === "1";
    if (!useNorm) return raw;
    const mod = await import("../utils/normalize");
    return mod.normalizeBatch(raw, target);
  } catch {
    return raw;
  }
}
